/* istanbul ignore file */
import { DataGridLayout } from 'framework/list';
import { TextField, DateField } from 'framework/ui/field';
import { EmployeeLinkField } from 'domain/shared/employee';
import ArtifactStorageFileField from 'domain/shared/artifactStorage/field/ArtifactStorageFileField';
import ArtifactStorageAdditionalInfoField from 'domain/documents/artifactStorage/shared/field/ArtifactStorageAdditionalInfoField';
import {
  ArtifactStorageHashTooltip,
  ArtifactStorageOneFileLink,
  ArtifactStorageTypeIcon,
} from 'domain/shared/artifactStorage';
import ArtifactStorageSizeField from 'domain/shared/artifactStorage/field/ArtifactStorageSizeField';
import DownloadArtifactButton from 'domain/documents/artifactStorage/shared/button/DownloadArtifactButton';

const ArtifactStorageFilesListLayout = () => {
  return (
    <DataGridLayout
      sxTableWrapper={{ '&& .th-buttons': { width: '130px' } }}
      buttons={[<DownloadArtifactButton source="file.artifact" />]}
    >
      <ArtifactStorageOneFileLink source="file.id" label="ID" width={65} />
      <ArtifactStorageTypeIcon label="" source="type" width={45} />
      <ArtifactStorageFileField label="Name" source="file.artifact" />
      <DateField source="file.createdAt" label="Created at" />
      <EmployeeLinkField nameSource="file.createdByName" source="file.createdById" label="Created by" />
      <TextField
        source="file.artifact.hash"
        label={
          <>
            Hash <ArtifactStorageHashTooltip />
          </>
        }
      />
      <ArtifactStorageSizeField source="file.artifact.size" label="Size" />
      <ArtifactStorageAdditionalInfoField
        source="file.metaInformation"
        additionalSource="file.artifactRelation"
        label="Additional information"
      />
    </DataGridLayout>
  );
};

export default ArtifactStorageFilesListLayout;
